import {
    SET_PRIMARY_APPROVER
} from './PrimaryApproverType';


const reducers = (state = [], action: any) => {
    if (action.type === SET_PRIMARY_APPROVER) {
        return {
            ...state,
            primaryApproverList: action.primaryApproverList,
        };
    }
    else {
        return state;
    }
}

export {
    reducers
}